import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi =
  ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents/{agentId}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateQuestionnaireAgent = async ({
  agentId,
  creatorId,
  questionnaireTemplateId,
  agent,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(
    '/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents/{agentId}',
    { agentId, creatorId, questionnaireTemplateId },
  );
  const data = await formsBackendClient.put(path, { agent });
  return data.data;
};

export default updateQuestionnaireAgent;
